import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiService, HttpMethod } from '../common/api.service';
import { ApiUrlService } from '../common/api-url.service';

@Injectable({
    providedIn: 'root'
})
export class MemberApiService
{
    protected apiService: ApiService;

    constructor(protected http: HttpClient,
                protected apiUrlService: ApiUrlService)
    {
        this.apiService = new ApiService(http);
    }

    addFavoriteImage(imageAssetId: number): Observable<any>
    {
        return this.apiService.apiRequest(this.apiUrlService.addOrRemoveFavoriteUrl(imageAssetId), HttpMethod.Post);
    }

    deleteFavoriteImage(imageAssetId: number): Observable<any>
    {
        return this.apiService.apiRequest(this.apiUrlService.addOrRemoveFavoriteUrl(imageAssetId), HttpMethod.Delete);
    }
}
